<template>
  <div class="checkout-builder-footer">
    <bp-button
      v-if="snapshots.length"
      color="neutral"
      variant="filled-1"
      label="Desfazer tudo"
      icon="fa-regular fa-undo"
      @click="reset"
    />
    <bp-button
      label="Salvar novo checkout"
      :loading="loading"
      :disabled="!snapshots.length"
      @click="save"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState("checkoutBuilder", [
      "checkoutBuilder",
      "background",
      "components",
      "snapshots"
    ])
  },
  methods: {
    reset() {
      this.$store.dispatch("checkoutBuilder/setCheckoutState", {
        ...this.checkoutBuilder
      });
      this.$store.commit("checkoutBuilder/setSnapshots", []);
    },
    async save() {
      const checkout = { ...this.checkoutBuilder, title: "checkout" };
      let components = [...this.components];

      let action = "checkoutBuilder/put";
      if (!checkout.id) {
        delete checkout.id;
        action = "checkoutBuilder/post";
        checkout.product_id = this.$route.params.id;
      }

      checkout.config = {
        ...checkout.config,
        textColor: "unset",
        longPage: !!checkout.config?.longPage
      };
      checkout.type = "custom";

      checkout.background_image = this.background.image || null;
      checkout.config.backgroundColor = this.background.color;

      const timer = components.find(c => c.type == "timer" && !c.deleted);
      checkout.config.countdown = !!timer;
      if (timer) {
        delete timer["type"];
        components = components.filter(c => c.type != "timer");
        checkout.config = {
          ...checkout.config,
          ...timer
        };
      }
      const deletedComponents = components.filter(c => c.deleted && c.id > 0);

      checkout.components = components
        .filter(c => !c.deleted && !c.countdown)
        .map(c => ({
          ...c,
          ...(checkout.id ? { checkout_build: checkout.id } : {}),
          config: {
            ...c.config,
            "padding-left": "unset",
            "padding-right": "unset",
            "padding-top": "unset",
            "padding-bottom": "unset",
            "margin-top": "unset",
            "margin-bottom": "unset",
            "border-radius": "4px"
          }
        }));

      this.loading = true;

      try {
        await Promise.all(
          deletedComponents.map(c =>
            this.$store.dispatch("checkoutBuilder/deleteComponent", c.id)
          )
        );
        setTimeout(() => {
          this.$store
            .dispatch(action, checkout)
            .then(({ data }) => {
              this.$store.dispatch("checkoutBuilder/setCheckoutState", data);
            })
            .then(() => {
              this.$message.success("Checkout salvo!");
              this.$store.commit("checkoutBuilder/setSnapshots", []);
            })
            .finally(() => (this.loading = false));
        }, 500);
      } catch (error) {
        this.$message.error("Erro ao salvar checkout.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-footer {
  background: var(--Surface-Transparent-16, rgba(252, 252, 253, 0.92));
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
  position: absolute;
  padding: 12px;
  width: 100%;
  bottom: 0;

  gap: 16px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media screen and (min-width: 992px) {
    align-items: center;
    flex-direction: row;
  }
}
</style>
